import domReady from '@wordpress/dom-ready';
import { isSafariBrowser } from '../../src/utils/helper';

domReady( () => {
    if ( document.body.matches( '.is-safari' ) ) {
        return;
    }
    if ( isSafariBrowser() ) {
        document.body.classList.add( 'is-safari' );
    }
} );
